import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, Grid, Pagination, Popover, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import visa_icon from '../../assets/icons/visa.png'
import vnpay_icon from '../../assets/icons/vnpay.png'
import acb_icon from '../../assets/icons/acb.png'
import momo_icon from '../../assets/icons/momo.png'
import true_icon from '../../assets/icons/true.png'
import pending_icon from '../../assets/icons/pending.png'
import false_icon from '../../assets/icons/false.png'
import download_icon from '../../assets/icons/download.svg'
import closeIcon from '../../assets/icons/payment/close.svg'
import useStyles from "./style"
import helper from "@utils/helper";
import clsx from 'clsx'
import { Icon, IconButton, InputAdornment } from "@material-ui/core";
import styles from "./List.module.scss";
import classNames from "classnames";
import Spinner from "@components/common/Spinner/Spinner";
import { useParams } from "react-router";
import { useDispatch } from "react-redux";
import { fetchBalanceRequest, fetchCancelRequest, fetchOrderRequest, fetchUserRequest } from "@redux/User/action";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RegisterPackage from "@components/common/toolbar/registerPackage";
import { useTranslation } from "react-i18next";
const PaymentUserDetails =()=>{
    const {t} = useTranslation();
    console.log(t)
    const columnTitle = [
        { name: 'ID giao dịch' },
        { name: 'Thời gian TT' },
        { name: 'Tên Giao dịch' },
        { name: 'Số tiền' },
        { name: 'Hình thức' },
        { name: 'Trạng thái' },
        { name: 'Tải xuống' }
    ];
    
    const STATUS = {
        SUCCESS: 'success',
        FAILURE: 'failure',
        PENDING: 'pending'
    }
        const STATUS_ICON_MAP = {
        'success': true_icon,
        'pending': pending_icon,
        'failure': false_icon,
    }
    const classes = useStyles();
    const dispatch = useDispatch();
    const [list, setList] = useState([]);
    const [selectedArray, setSelectedArray] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0)
    const grayColor = '#4C4C4C';
    const [currentBal, setCurrentBal]=useState(0);
    const [invoiceDetails, setInvoiceDetails] = useState([])
    const [anchorEl, setAnchorEl] = useState(null)
    const handleCloseTransactionDetail = () => setAnchorEl(null)
    const [dialogCancel,setDialogCancel] = useState(false)
    const [draw, setDraw] = useState(false);
    const [btnSubmit, setBtnSubmit] = useState(false);
    const [currency,setCurrency] = useState("VND")
    const [plan, setPlan] = useState([]);
    const [reason,setReason] = useState("")
    const handleChangeReason = (e) => {
        setReason(e?.target?.value || "")
      };
    const { loading } = useSelector((state) => ({
        loading: state?.toUserManager.loading,
      }));
      const [isLoading, setLoading] = useState(null)
      useEffect(()=>{
        setLoading(loading)
      },[loading])
    const handleClickItem = (e, data) => {
        setCurrency(data?.currency || "VND")
        setInvoiceDetails(data?.invoiceDetails || [])
        setAnchorEl(e.currentTarget)
    }
    function getTime(createdAt){
        const d = new Date(createdAt);
        return (
          <div style={{ width: "100%" }}>
            {`${d.toLocaleTimeString("vi", {
              hour: "2-digit",
              minute: "2-digit",
            })} - ${d.toLocaleDateString("vi", {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit",
            })}`}
          </div>
        );
    }
    function ControlledPagination() {
        const handleChange = (event, value) => {
          setPage(value);
        };
        console.log(totalPage, page)
        return (
          <Pagination
            count={totalPage}
            page={page}
            onChange={handleChange}
            variant="outlined"
            shape="rounded"
          />
        );
      }
      const {id} = useParams();
      const {orderResult, currentBalance, planPackage, totalPageOrder} = useSelector((state)=> state.toUserManager);
      const toggleDrawer = (open) => {
        setDraw(open);
    };
    const handleClose = ()=>{
        setDialogCancel(false)
    }
    const handleCancel = async()=>{
        if(reason && reason!==""){
            await dispatch(fetchCancelRequest({body:{reason, id}}));
            handleClose()
            setDialogCancel(false)
        }
    }
      useEffect(()=>{
        dispatch(fetchOrderRequest({params:{ page: page,
                                            id: id}}))
        dispatch(fetchBalanceRequest({params:{id: id}}))
      },[id, page])

      useEffect(()=>{
        console.log(orderResult)
        setTotalPage(totalPageOrder)
        setList(orderResult);
        setCurrentBal(currentBalance);
        setPlan(planPackage.currentBalance)
      },[orderResult, currentBalance, planPackage]);
    return (
        <>
            <div className={classes.header}>
                <div className={classes.wrapIconClose}>
                    <Link to="/admin/user-management">
                    <IconButton className={classes.drawIconClose}>
                        {/* <img src={closeIcon} alt="closeIcon" /> */}
                        <ArrowBackIcon className={classes.drawIconClose}/>
                    </IconButton>
                    </Link>
                    <span className={classes.textClose}>Thoát</span>
                </div>
            </div>
            <div className={classes.root}>
                <div className={classes.transactionToolbar}>
                    <Grid container alignItems='flex-end' justifyContent='space-between' className={classes.toolbarContainer}>
                        <Box>
                            <span className={classes.currentBalance}>{helper.formatCash.format(currentBal === undefined ? 0 : currentBal)}</span>
                            <span>Số dư hiện tại</span>
                        </Box>
                        <Box sx={{ display: 'flex', '& button': { margin: '0px 5px', padding: '5px 15px', textTransform: 'none' } }}>
                            {
                                plan?.plan?.includes("custom") && <Button
                                    style={{ color: "#5D5D5D", backgroundColor: "#EFF0F0" }}
                                    variant="outlined"
                                    size='small'    
                                    className={clsx(classes.btnToday)}
                                    onClick={() => setDialogCancel(true)}
                                // disabled={btnSubmit}
                                >
                                    Hủy gói custom
                                </Button>
                            }
                            <Button
                                style={{background:"#41B60B", color:"white"}}
                                variant=""
                                size='small'
                                className={classes.btnToday}
                                onClick={() => toggleDrawer(true)}
                                disabled={btnSubmit}
                            >
                                Đăng ký gói custom
                            </Button>
                            <Button style={{ color: "#5D5D5D", backgroundColor: "#EFF0F0" }} startIcon={<img src={download_icon} alt="download-icon" />} variant="" size='small'
                                className={classes.btnToday}
                                onClick={(e) => {
                                }}
                            >
                                Tải xuống
                            </Button>
                        </Box>
                    </Grid>
                </div>
            </div>
            <Grid container direction={"column"} className={styles?.Wrapper}>
                <Table>
                    <TableHead sx={{ backgroundColor: '#F6F6F7' }}>
                        <TableRow>
                            {columnTitle.map((value) => {
                                return (
                                    <TableCell align="center" key={value.key}>
                                        <Typography className={styles.TableCellTitle} sx={{ fontWeight: '600' }}>
                                            {value.name}
                                        </Typography>
                                    </TableCell>
                                )
                            }
                            )}
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    
                    <TableBody>
                        {list?.map((element, index) => {
                            const word = element.description;
                            const filterWord  = word.split(" ").filter(a => a.includes('payment.'))[0]
                            const isNinetickEmail = ['ninetick', 'ninetick-email'].includes(element?.custom?.service) && (!element?.custom?.feature || element?.custom?.feature === 'email')
                            const emailDescription = ['credit', 'email-credit'].includes(element?.custom?.action)
                                ? `Ninetick email credit: ${element?.custom?.emailCreditQuantity || 0} email`
                                : `Ninetick email package: ${element?.custom?.planName || element?.custom?.planCode || ''} (${element?.custom?.emailMonthlyLimit || 0} email/tháng)`
                            console.log(filterWord)
                            return (
                                <TableRow 
                                    key={index}
                                    className={classNames(
                                        styles.PaperItem,
                                        styles.OrderItem,
                                        selectedArray.includes(element.default) && styles.PaperActive
                                    )}
                                    onClick={(e)=>handleClickItem(e, element)}
                                >
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>{element.id}</TableCell>
                                    <TableCell align="center" >{getTime(element?.createdAt)}</TableCell>
                                    {isNinetickEmail ? <TableCell align="center" style={{ fontWeight: "bold", fontSize:"16px" }}>{emailDescription}</TableCell> :
                                    filterWord ? <TableCell align="center" style={{ fontWeight: "bold", fontSize:"16px" }}>{t(`${filterWord}`)} {element.description.split(" ")[1]}</TableCell>:
                                    <TableCell align="center" style={{ fontWeight: "bold", fontSize:"16px" }}>{t(`${element?.description}`)}</TableCell>
                                    }
                                    
                                    <TableCell align="center" >
                                        {
                                            element.currency==="USD"
                                            ? helper.formatCashLanguage("USD",element.amount)
                                            : helper.formatCash.format(element.amount)
                                        } 
                                    </TableCell>
                                    <TableCell align="center">{element?.paymentTypeDetail?.title}</TableCell>
                                    <TableCell align="center">
                                        <span style={{ fontSize: '15px', fontWeight: 400, color: grayColor, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent:"center" }}>
                                            <div className={classes.cellLeftIcon}>
                                                {!!STATUS_ICON_MAP[element?.status] && <img src={STATUS_ICON_MAP[element?.status]} alt="" />}
                                            </div>
                                            &nbsp;
                                            {element?.statusDetail?.title || element?.status || ''}
                                        </span>
                                    </TableCell>
                                    <TableCell align="center">
                                        <span>
                                            <img src={download_icon} style={{ width:"20px" }} alt="download icon"/>
                                        </span>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
                <Grid container display="flex" justifyContent="center" m={5}>
                    <Stack spacing={2}>
                        <ControlledPagination />
                    </Stack>
                </Grid>
                {list.length > 0 ? null
                    :
                    <Grid container display="flex" justifyContent="center" mt={5} style={{ marginRigth: "-50% !important" }}>
                        <Grid item >
                            <Typography spacing={2}>
                                Chưa có giao dịch
                            </Typography>
                        </Grid>
                    </Grid>
                }
            </Grid>
            <Popover
                    open={Boolean(anchorEl)}
                    onClose={handleCloseTransactionDetail}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    classes={{
                        paper: classes.itemDetail
                    }}
                    style={{marginTop: "40px"}}
                >
                    <Box>
                        {invoiceDetails.map((invoiceDetail, i) => {
                            const billingDate = new Date(invoiceDetail.date)
                            return (
                                <Grid key={i} container className={classes.dailyInvoiceDetail}>
                                    <Grid container>
                                        <Grid item xs>
                                            <b style={{ fontWeight: '700', fontSize: '18px', color: '#131313' }}>
                                                {billingDate.toLocaleDateString('vi', {
                                                    timeZone: 'Asia/Ho_Chi_Minh',
                                                    weekday: 'long',
                                                    day: 'numeric',
                                                    month: '2-digit',
                                                    year: 'numeric'
                                                })}
                                            </b>
                                        </Grid>
                                    </Grid>
                                    {invoiceDetail?.items?.map((invoiceLineItem, j) => (
                                        <Grid key={j} container justifyContent='space-between' style={{ padding: '2rem 0', borderBottom: j < invoiceDetail.items.length - 1 ? '1px solid #ECECEC' : '' }}>
                                            <Grid item xs container justifyContent='flex-start'>
                                                <span style={{ fontWeight: '600', fontSize: '14px', color: '#4C4C4C' }}>
                                                    {invoiceLineItem.description || 'Chưa biết code động hay code tĩnh'}
                                                </span>
                                            </Grid>
                                            {invoiceLineItem?.details?.type !== 'plan' && !!invoiceLineItem?.details?.quantity && (
                                                <Grid item xs>
                                                    <span style={{ fontWeight: '400', fontSize: '14px', color: '#4C4C4C' }}>
                                                        Số lượng: {invoiceLineItem.details?.quantity || 0}
                                                    </span>
                                                </Grid>
                                            )}
                                            <Grid item xs container justifyContent='flex-end'>
                                                <span style={{ fontWeight: '400', fontSize: '14px', color: '#4C4C4C' }}>
                                                    {
                                                        invoiceLineItem?.currency==='USD'
                                                        ? helper.formatCashLanguage("USD",invoiceLineItem.amount)
                                                        : helper.formatCash.format(invoiceLineItem.amount)
                                                    }
                                                </span>
                                            </Grid>
                                        </Grid>
                                    ))}
                                    <Grid container justifyContent='space-between' style={{ padding: '2rem 0' }}>
                                        <Grid item xs container justifyContent='flex-end'>
                                            <b style={{ fontWeight: '700', fontSize: '14px', color: '#131313' }}>
                                                Tổng: {
                                                    currency==="USD"
                                                    ? helper.formatCashLanguage("USD",invoiceDetail.items.map(t => t.amount).reduce((c, i) => c + i, 0))
                                                    : helper.formatCash.format(invoiceDetail.items.map(t => t.amount).reduce((c, i) => c + i, 0))
                                                }
                                            </b>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        })}
                    </Box>
                </Popover>
                {isLoading && <Spinner />}
            {
                draw && <RegisterPackage
                    open={draw}
                    onClose={() => toggleDrawer(false)}
                    toggleDrawer={toggleDrawer}
                    id={id}
                />
            }
            <Dialog open={dialogCancel} onClose={handleClose} className={classes.dialogContent}>
                <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', padding: '34px 43px', width: '423px' }}>
                    <Box sx={{ fontSize: '20px', fontWeight: '500', color: '#000000' }}>
                        Lý do huỷ giao dịch
                    </Box>
                    <Box sx={{ color: '#41B60B', padding: '24px 0px', width: "100%" }}>
                        <TextField
                            label="Nhập lý do"
                            multiline
                            onChange={handleChangeReason}
                            fullWidth
                            error={reason !== "" ? false : true}
                            helperText={reason !== "" ? "" : "Vui lòng nhập lý do"}
                        />
                    </Box>
                    <Box sx={{
                        display: 'flex', marginTop: '24px', justifyContent: 'space-between', width: '100%',
                        '& .MuiButton-root': {
                            padding: '5px 30px',
                            width: '48%'
                        }
                    }}>
                        <Button onClick={handleClose} variant='contained' style={{ background: "#E0E0E0", color: "black" }}> Huỷ</Button>
                        <Button
                            style={{ background: "#C62026", color: "white" }}
                            variant="contained"
                            onClick={handleCancel}
                        > Xong
                        </Button>
                    </Box>
                </Box>

            </Dialog>
        </>
    );
}
export default PaymentUserDetails;
